import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface InvestorSlide12Props {
  isDark?: boolean;
}
export function InvestorSlide12({
  isDark = false
}: InvestorSlide12Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const team = [{
    name: 'Ebrima A. Sisay',
    title: 'CEO & Founder',
    image: 'https://cdn.magicpatterns.com/uploads/ggwavy6HEhSdAGirbPC9EV/Ebrima_Abraham_Sisay.png',
    cred: 'Leadership Development Expert',
    objectPosition: 'center'
  }, {
    name: 'Dr. Katie Gaebel',
    title: 'COO',
    image: 'https://cdn.magicpatterns.com/uploads/a9G7BAyJCCoxe6nbRhxJLz/Dr._Katie_Gaebel.png',
    cred: 'PhD, Organizational Psychology',
    objectPosition: 'center'
  }, {
    name: 'Cosmin Artene',
    title: 'CTO',
    image: 'https://cdn.magicpatterns.com/uploads/7hP7aEkQVDiR6iLMKZ4TkU/Cosmin_Artene.png',
    cred: 'Enterprise SaaS Architect',
    objectPosition: 'center'
  }, {
    name: 'Bethriz D. Roa',
    title: 'Head of Customer Success',
    image: 'https://cdn.magicpatterns.com/uploads/hPqbAku9SyevWAARTAD74e/Bethriz_Donita_Roa.png',
    cred: 'Client Experience Specialist',
    objectPosition: 'center'
  }, {
    name: 'Curtis Edlin',
    title: 'Head of Production',
    image: 'https://cdn.magicpatterns.com/uploads/3ENZKh7cGcGm2g65UAm2sS/Curtis_Edlin.jpg',
    cred: 'Video & Content Production',
    objectPosition: 'center top'
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-200">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-201">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-202">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-203">
            The Team
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-204">
            Deep expertise in leadership development, clinical psychology, and
            enterprise SaaS.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 sm:gap-8" data-id="element-205">
          {team.map((person, idx) => <motion.div key={idx} variants={itemVariants} className="text-center group" data-id="element-206">
              <div className="relative mb-4 sm:mb-6" data-id="element-207">
                <div className="absolute inset-0 bg-heliona-mint/10 rounded-full blur-xl group-hover:bg-heliona-mint/20 transition-colors duration-300" data-id="element-208"></div>
                <img src={person.image} alt={person.name} style={{
              objectPosition: person.objectPosition
            }} className={`relative w-24 h-24 sm:w-28 sm:h-28 rounded-full object-cover mx-auto border-2 shadow-lg ${isDark ? 'border-white/20' : 'border-heliona-beige'}`} data-id="element-209" />
              </div>
              <h3 className={`font-bold text-base sm:text-lg mb-1 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-210">
                {person.name}
              </h3>
              <p className={`text-xs sm:text-sm font-semibold mb-1 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-211">
                {person.title}
              </p>
              <p className={`text-xs ${isDark ? 'text-white/60' : 'text-heliona-text-gray'}`} data-id="element-212">
                {person.cred}
              </p>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}